import { useMutation } from "@tanstack/react-query";
import { register, RegisterCredentials, AuthResult } from "../../lib/services/authService";

/**
 * useRegister: React Query mutation hook for registration operation.
 * Usage: const { mutate: register, isLoading, error, data } = useRegister();
 */
export function useRegister() {
  return useMutation<AuthResult, Error, RegisterCredentials>({
    mutationKey: ["auth", "register"],
    mutationFn: register,
  });
}
